import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import "./stampingToolCapabilities.css"
import logoStampingToolPT from "../../imagens/logos/logoStampingTool.png"
import logoStampingToolEN from "../../imagens/logos/logoStampingToolEn.png"
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";

function StampingToolToolCapabilities({ listStampingTool }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const { i18n } = useTranslation()
    const language = i18n.language

    const handleCloseModal = () => setOpenModal(false)
    const handleOpenModal = (index) => {
        setOpenModal(true)
        setSlideNumber(index)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0
            ? setSlideNumber(listStampingTool.length - 1)
            : setSlideNumber(slideNumber - 1)
    }, [slideNumber, listStampingTool.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listStampingTool.length
            ? setSlideNumber(0)
            : setSlideNumber(slideNumber + 1)
    }, [slideNumber, listStampingTool.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break
                case 'ArrowRight':
                    nextSlide()
                    break
                default:
                    break
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown)
        }

        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [openModal, nextSlide, prevSlide])

    return (
        <div>
            {/* Logo PT / EN */}
            <div>
                <img
                    className='img-custom-size img-fluid ms-2'
                    src={language === "en" ? logoStampingToolEN : logoStampingToolPT}
                    alt='logoStampingTool'
                />
            </div>

            {/* Modal */}
            {openModal && (
                <div className='stampingToolSliderWrap'>
                    <FontAwesomeIcon className='stampingToolBtnPrev' icon={faCircleChevronLeft} onClick={prevSlide} />
                    <FontAwesomeIcon className="stampingToolBtnNext" icon={faCircleChevronRight} onClick={nextSlide} />
                    <FontAwesomeIcon className='stampingToolBtnClose' icon={faCircleXmark} onClickCapture={handleCloseModal} />
                    <img className="stampingToolFullScreen" src={listStampingTool[slideNumber].img} alt='imgStampingTool' />
                </div>
            )}

            {/* Gallery */}
            <div className="stampingToolGalleryWrap">
                {listStampingTool?.map((image, index) => (
                    <div
                        className="stampingToolSingle"
                        key={index}
                        onClick={() => handleOpenModal(index)}
                    >
                        <img src={image.img} alt="stampingTool" />
                    </div>
                ))}
            </div>

            {/* Back button */}
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/ToolingAndManufacturing">
                    <button className="stampingToolButton">
                        {language === "pt"
                            ? "Voltar à fabricação de ferramental"
                            : "Back to tooling design and manufacturing"}
                    </button>
                </Link>
            </div>

        </div>
    )
}

export default StampingToolToolCapabilities
